module.exports = __webpack_public_path__ + "static/03-9facd79dddff1d1088cd087b4469309f.jpg";